import { useAccount } from 'frontastic/hooks';
import { useWishlist } from 'frontastic/hooks';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useRef, useEffect } from 'react';
import toast from 'react-hot-toast';

function useAddToWishlistBackground() {
  const { account } = useAccount();
  const { addToWishlist } = useWishlist();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const sku = searchParams.get('sku');
  const hasAddedToWishlist = useRef(false);

  useEffect(() => {
    const shouldAddToWishList = searchParams.get('addToWishList') === 'true';

    async function addProductToWishlist() {
      if (account && sku && shouldAddToWishList && !hasAddedToWishlist.current) {
        try {
          hasAddedToWishlist.current = true;
          await addToWishlist(sku, 1);
          toast.success('Item Added');

          const newSearchParams = new URLSearchParams(searchParams);
          newSearchParams.delete('addToWishList');
          newSearchParams.delete('sku');

          router.replace(`${pathname}?${newSearchParams}`);
        } catch (e) {
          toast.error((e as Error)?.message);
        }
      }
    }

    addProductToWishlist();
  }, [account, sku, searchParams]);

  return null;
}

export default useAddToWishlistBackground;
